export const TRANSLATION_GROUP_AFFILIATE_CREATIVES = Symbol('affiliate.creatives');

export const AFFILIATE_TRACKERS_CREATIVES_ROUTE_NAME = Symbol('affiliate.trackers.creatives');

export const AFFILIATE_TRACKERS_CREATIVES_LIST_URL = 'affiliate/creatives/:type/list';
export const AFFILIATE_TRACKERS_CREATIVES_LIST_QUERY_KEY = 'affiliate.trackers.creatives.list';

export const AFFILIATE_TRACKERS_CREATIVES_OPTIONS_URL = 'affiliate/creatives/options';
export const AFFILIATE_TRACKERS_CREATIVES_OPTIONS_QUERY_KEY = 'affiliate.trackers.creatives.options';

export const AFFILIATE_TRACKERS_CREATIVES_LINK_URL = 'affiliate/creatives/link/redirect_link';
export const AFFILIATE_TRACKERS_CREATIVES_LINK_QUERY_KEY = 'affiliate.trackers.creatives.link';
